import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';

import { setAlert } from '../../../actions/alert';
import { limpiarMembresiaConfiguracion, obtenerMembresiaConfiguracion, editarMembresiaConfiguracion } from '../../../actions/configuracion';

const EditarMembresia = ({ membresia, reestablecerMembresia }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.membresias);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [membresiaData, setMembresiaData] = useState({
        id: null,
        nombre: null,
        precio: 0,
        descripcion: null, 
        beneficios: []
    });

    /* Editar membresia */
    const handleInputChange = ({ target }) => {
        setMembresiaData({
            ...membresiaData,
            [target.name]: target.value
        });
    }

    const handleNumberChange = (value) => {
        setMembresiaData({
            ...membresiaData,
            precio: value || ''
        });
    }

    const handleChangeBeneficio = (posicion, { target }) => {
        let beneficios = membresiaData.beneficios;

        beneficios[posicion] = target.value;

        setMembresiaData({
            ...membresiaData,
            beneficios
        });
    }

    const handleAgregarBeneficio = () => {
        let beneficios = membresiaData.beneficios;

        beneficios.push('');

        setMembresiaData({
            ...membresiaData,
            beneficios
        });
    }

    const handleEliminarBeneficio = (posicion) => {
        let beneficios = membresiaData.beneficios;

        beneficios.splice(posicion, 1);

        setMembresiaData({
            ...membresiaData,
            beneficios
        });
    }
    
    const handleProcesar = async () => {
        if(membresiaData.nombre && membresiaData.beneficios?.length){
            await setStatusProcesar(true);
            await dispatch(editarMembresiaConfiguracion(membresiaData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('El nombre y al menos un beneficio son necesarios', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){

            setMembresiaData({
                id: null,
                nombre: null,
                precio: 0,
                descripcion: null, 
                beneficios: []
            });

            setEditarModal(false);

            reestablecerMembresia(null);
        }
    }

    /* Funciones generales */
    const createFilasBeneficios = () => {

        let beneficios_campos = [];

        let beneficios = membresiaData.beneficios;

        if(beneficios?.length > 0){
            for (let x = 0; x < beneficios?.length; x++) {
                beneficios_campos.push(
                    <div className="col-md-12 mb-3 row" key={'beneficio_' + x}>
                        <div className="input-group h-100">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder={'Beneficio ' + (x + 1)} value={beneficios[x] || ''} onChange={e => handleChangeBeneficio(x, e)} />
                                <label className="font-weight-bold">{'Beneficio ' + (x + 1)}</label>
                            </div>

                            <div className="input-group-append">
                                <button className="btn btn-danger deleteField" onClick={e => handleEliminarBeneficio(x)}><i className="fa-solid fa-xmark"></i></button>
                            </div>
                        </div>
                    </div>
                );
            }
        }else{
            beneficios_campos.push(
                <div className="col-md-12 pt-3 text-center">
                    <h5>Agrega beneficios de esta membresia</h5>
                </div>
            );
        }

        return beneficios_campos;
    }

    useEffect(() => {
        dispatch(limpiarMembresiaConfiguracion());
    }, []);

    useEffect(() => {
        if(membresia){
            setEditarModal(true);
            
            dispatch(obtenerMembresiaConfiguracion(membresia?._id));

            setMembresiaData({
                ...membresiaData,
                id: membresia?._id
            });
        }
    }, [membresia]);

    useEffect(() => {
        if(detalles){
            setMembresiaData({
                ...membresiaData,
                id: detalles?._id, 
                nombre: detalles?.nombre, 
                precio: detalles?.precio, 
                descripcion: detalles?.descripcion, 
                beneficios: detalles?.beneficios
            });
        }
    }, [detalles]);

    return (
        <Modal show={editarModal} size="lg" backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar membresia</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-9 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={membresiaData.nombre} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="nombre">Nombre</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <CurrencyInput
                                    id="precio"
                                    name="precio"
                                    className="form-control text-center"
                                    value={membresiaData.precio || ''}
                                    decimalsLimit={2}
                                    groupSeparator=","
                                    decimalSeparator="."
                                    onValueChange={(value) => handleNumberChange(value)}
                                />
                                <label htmlFor="precio">Precio</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Descripción" id="descripcion" name="descripcion" value={membresiaData.descripcion} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="descripcion">Descripción</label>
                            </div>
                        </div>
                    </div>

                    <hr className="my-4" />

                    { createFilasBeneficios() }
                </div>                   
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <>
                            <button type="button" className="btn btn-primary" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Beneficio</button>
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                        </>
                    :
                        <>
                            <button type="button" className="btn btn-primary" onClick={() => handleAgregarBeneficio()}><i className="fas fa-plus fa-sm"></i> Beneficio</button>
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarMembresia;